import { render, staticRenderFns } from "./Ongoing.vue?vue&type=template&id=3db937c6&scoped=true"
import script from "./Ongoing.vue?vue&type=script&lang=js"
export * from "./Ongoing.vue?vue&type=script&lang=js"
import style0 from "./Ongoing.vue?vue&type=style&index=0&id=3db937c6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db937c6",
  null
  
)

export default component.exports